import { MensagemStatusEnum } from "../../../enum/mensagens/mensagem-status.enum";
import { MensagemTipoEnum } from "../../../enum/mensagens/mensagem-tipo.enum";
import { MensagemBotao } from "./mensagem-botao.model";
import { MensagemOpcaoLista } from "./mensagem-opcao-lista.model";

export class MensagemModel {
  id!: string;
  metaId!: string;
  mensagem!: string;
  mensagemCabecalho!: string;
  mensagemRodape!: string;
  urlImage!: string;
  botoes!: MensagemBotao[];
  uuidImage!: string;
  sendBy!: MensagemTipoEnum;
  type!: string;
  date!: Date;
  status!: MensagemStatusEnum;
  nomeUsuarioEnvio!: string;
  nome!: string;
  contato!: string;
  idUsuarioEnvio!: number;
  tipoAnexo!: string;
  isTemplate!: boolean;
  extensao!: string;
  reacao!: string;
  reacaoUsuarioId?: number;
  reacaoUsuarioNome?: string;
  reacaoUsuarioUuid?: string;
  reacaoUsuarioExtensaoImg?: string;
  idTemplateMeta?: string;
  opcoes!: MensagemOpcaoLista[];
  isMensagemTemp?: boolean
  enviando?: boolean;
  arquivoLocal?: File;
  mensagemResposta?: MensagemModel;
  erroMensagem?: string;
  formatada?: boolean = false;
  mensagemFormatada?: string;
  disparoId?: number
  numEnvio?: string

  constructor(mensagem: string) {
    this.mensagem = mensagem;
  }
}
